/*
 * Gorgias chat skin — "Czat z Wiktorią" (Claude Design: Czat na stronie / Czat Wiktoria).
 *
 * The native Gorgias widget stays in charge of the conversation; this file only:
 *  - replaces the native launcher with our own button + adds the delayed invitation card (host page),
 *  - injects a stylesheet and a few DOM pieces (header, gate copy, WhatsApp/phone row) into the
 *    same-origin #chat-window iframe,
 *  - sets the Polish copy through GorgiasChat.updateTexts and patches the few strings the API does not cover.
 *
 * Gorgias class names are emotion hashes, so selectors rely on ids, data-testid, aria and structure only.
 * Config comes from snippets/gorgias-chat-skin.liquid (window.nkChatSkin).
 */
(function () {
  'use strict';

  var CFG = window.nkChatSkin || {};
  var NAME = 'Wiktoria Wójtowicz';
  var ROLE = 'Dedykowane wsparcie klienta';
  var PHONE_LABEL = '+48 530 680 055';
  var PHONE_HREF = 'tel:+48530680055';
  var WA_HREF = 'https://wa.me/48530680055';
  var GREETING = 'Dzień dobry, jeśli masz pytania, napisz do mnie. Jestem dostępna i chętnie pomogę.';
  var GATE_COPY = 'Podaj e-mail, żebym mogła odpowiedzieć także wtedy, gdy zamkniesz to okno.';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var TEASER_DELAY = 1500;
  var TEASER_SEEN_KEY = 'nk-chat-teaser-seen';
  var MOBILE_MQ = window.matchMedia('(max-width: 767px)');

  var root = document.documentElement;
  var api = null;

  var ICON_ARROW = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var ICON_PHONE = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>';
  var ICON_CLIP_URL = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6D7878" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>');
  var ICON_CLOSE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  var ICON_X_LAUNCHER = '<svg class="nk-chat-launcher__x" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#244545" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  var ICON_BUBBLE = '<svg class="nk-chat-launcher__bubble" width="26" height="26" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5a9.5 9.5 0 0 0-8.3 14.1L2.5 21.5l5-1.3A9.5 9.5 0 1 0 12 2.5z" fill="#244545"/><circle cx="8" cy="12" r="1.3" fill="#fff"/><circle cx="12" cy="12" r="1.3" fill="#fff"/><circle cx="16" cy="12" r="1.3" fill="#fff"/></svg>';

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function avatarHtml(size, dot) {
    return '<span class="nk-av" style="--nk-av:' + size + 'px;--nk-dot:' + dot + 'px">' +
      '<img src="' + esc(CFG.avatar) + '" alt="' + NAME + '" width="' + size + '" height="' + size + '">' +
      (dot ? '<span class="nk-av__dot"></span>' : '') + '</span>';
  }

  function altLinksHtml(compactPhone) {
    return 'Jestem też tutaj:' +
      '<a href="' + WA_HREF + '" target="_blank" rel="noopener"><img src="' + esc(CFG.whatsappIcon) + '" alt="" width="16" height="16">WhatsApp</a>' +
      '<a href="' + PHONE_HREF + '">' + ICON_PHONE + (compactPhone ? 'zadzwoń' : PHONE_LABEL) + '</a>';
  }

  function storage(fn) {
    try { return fn(window.sessionStorage); } catch (e) { return null; }
  }

  /* ---------------------------------------------------------------- host: launcher + invitation */

  var launcher, teaser, teaserTimer;

  function buildHostUi() {
    launcher = document.createElement('button');
    launcher.type = 'button';
    launcher.className = 'nk-chat-launcher';
    launcher.setAttribute('aria-label', 'Czat z obsługą klienta');
    launcher.innerHTML = ICON_BUBBLE + ICON_X_LAUNCHER + '<span class="nk-chat-launcher__badge" hidden></span>';
    launcher.addEventListener('pointerdown', onLauncherPress);
    launcher.addEventListener('click', onLauncherClick);

    teaser = document.createElement('div');
    teaser.className = 'nk-chat-teaser';
    teaser.setAttribute('role', 'dialog');
    teaser.setAttribute('aria-label', 'Zaproszenie do czatu');
    teaser.hidden = true;
    teaser.innerHTML =
      '<div class="nk-chat-teaser__card">' +
        '<div class="nk-chat-person">' + avatarHtml(40, 10) +
          '<div class="nk-chat-person__txt"><div class="nk-chat-person__name">' + NAME + '</div>' +
          '<div class="nk-chat-person__role">' + ROLE + '</div></div>' +
        '</div>' +
        '<p class="nk-chat-teaser__msg">' + GREETING + '</p>' +
        '<button type="button" class="nk-chat-teaser__cta">Napisz wiadomość<span>' + ICON_ARROW + '</span></button>' +
        '<div class="nk-chat-alt">' + altLinksHtml(MOBILE_MQ.matches) + '</div>' +
      '</div>';
    teaser.querySelector('.nk-chat-teaser__cta').addEventListener('click', function () {
      // Campaign shown in our card: reply through Gorgias so the campaign message starts the conversation.
      var reply = campaignBtn('reply-to-campaign-btn');
      endCampaign();
      hideTeaser();
      if (reply) reply.click(); else openChat();
    });

    document.body.appendChild(teaser);
    document.body.appendChild(launcher);
    root.classList.add('nk-chat-skin');
  }

  function showTeaser() {
    if (storage(function (s) { return s.getItem(TEASER_SEEN_KEY); })) return;
    if (api && api.isOpen && api.isOpen()) return;
    if (api && typeof api.isChatOnline === 'function' && !api.isChatOnline()) return;
    storage(function (s) { s.setItem(TEASER_SEEN_KEY, '1'); });
    teaser.hidden = false;
    setTimeout(function () { root.classList.add('nk-chat-teaser-on'); }, 20);
  }

  function hideTeaser() {
    clearTimeout(teaserTimer);
    if (campaignDoc) {
      var dismiss = campaignBtn('dismiss-campaign-btn');
      campaignDismissed = campaignText;
      endCampaign();
      if (dismiss) dismiss.click();
    }
    storage(function (s) { s.setItem(TEASER_SEEN_KEY, '1'); });
    root.classList.remove('nk-chat-teaser-on');
    teaser.hidden = true;
  }

  function openChat() {
    if (api) api.open();
  }

  /* Gorgias chat campaigns (e.g. product pages) render their own card in #chat-campaigns. We hide that
     iframe and show the campaign message in our invitation card; its native buttons stay the actions. */

  var campaignDoc = null, campaignText = '', campaignDismissed = '';

  function campaignBtn(testId) {
    return campaignDoc && campaignDoc.querySelector('[data-testid=' + testId + ']');
  }

  function endCampaign() {
    campaignDoc = null;
    campaignText = '';
    root.classList.remove('nk-chat-campaign-on');
    teaser.querySelector('.nk-chat-teaser__msg').textContent = GREETING;
  }

  function syncCampaign(doc) {
    var items = doc.querySelectorAll('[data-testid=campaign-item]');
    var quote = items.length === 1 && items[0].querySelector('blockquote');
    var text = quote ? quote.textContent.trim() : '';
    if (!text) {
      if (campaignDoc === doc) {
        endCampaign();
        root.classList.remove('nk-chat-teaser-on');
        teaser.hidden = true;
      }
      return;
    }
    if (text === campaignText || text === campaignDismissed) return;
    if (api && api.isOpen && api.isOpen()) return;
    campaignDoc = doc;
    campaignText = text;
    root.classList.add('nk-chat-campaign-on');
    teaser.querySelector('.nk-chat-teaser__msg').textContent = text;
    clearTimeout(teaserTimer);
    teaser.hidden = false;
    setTimeout(function () { root.classList.add('nk-chat-teaser-on'); }, 20);
  }

  function isChatOpen() {
    return root.classList.contains('nk-chat-open') || !!(api && api.isOpen && api.isOpen());
  }

  // State read on press: Gorgias can react to the press outside its iframe before our click fires,
  // so checking only in the click handler would see "closed" and reopen the chat.
  var openAtPress = null;

  function onLauncherPress() {
    openAtPress = isChatOpen();
  }

  function onLauncherClick() {
    var wasOpen = openAtPress === null ? isChatOpen() : openAtPress;
    openAtPress = null;
    if (root.classList.contains('nk-chat-teaser-on')) return hideTeaser();
    if (!api) return;
    if (wasOpen) api.close(); else api.open();
  }

  function setOpenState(open) {
    root.classList.toggle('nk-chat-open', !!open);
    if (open) hideTeaser();
  }

  function setUnread(count) {
    var badge = launcher.querySelector('.nk-chat-launcher__badge');
    badge.hidden = !(count > 0);
    badge.textContent = count > 9 ? '9+' : String(count || '');
  }

  /* ---------------------------------------------------------------- iframe skin */

  var IFRAME_CSS = [
    '@font-face{font-family:"nk-feixen";src:url("' + CFG.fontRegular + '") format("woff2");font-weight:400;font-style:normal;font-display:swap}',
    '@font-face{font-family:"nk-feixen";src:url("' + CFG.fontMedium + '") format("woff2");font-weight:500;font-style:normal;font-display:swap}',

    /* panel */
    /* panel: Gorgias sizes the dialog from the host viewport, pin it to the iframe (20px margin for the shadow).
       Media queries here would see the iframe width, so mobile comes as .nk-mobile from the host. */
    '[role=dialog][aria-labelledby=gorgias-chat-dialog-title]{font-family:"nk-feixen",system-ui,sans-serif!important;color:#244545;background:#fff!important;overflow:hidden!important;contain:paint}',
    'html:not(.nk-mobile) [role=dialog][aria-labelledby=gorgias-chat-dialog-title]{top:20px!important;left:20px!important;right:20px!important;bottom:20px!important;width:auto!important;height:auto!important;max-width:none!important;max-height:none!important;border-radius:16px!important;box-shadow:0 12px 40px rgba(11,30,30,.16),0 1px 3px rgba(11,30,30,.08)!important}',
    'html:not(.nk-mobile) [role=dialog][aria-labelledby=gorgias-chat-dialog-title]>div:not(.nk-head):not(.nk-chat-alt){width:100%!important;height:100%!important;max-height:none!important;top:0!important;left:0!important;right:auto!important;bottom:auto!important}',
    '[role=dialog][aria-labelledby=gorgias-chat-dialog-title] *{font-family:inherit!important;scrollbar-width:none}',
    /* while the self-service homepage flashes before we skip it */
    '[data-nk~=home]>div:not(.nk-head):not(.nk-chat-alt){opacity:0!important}',

    /* our header replaces Gorgias' floating header, the logo hero and the homepage gradient */
    '.nk-head{position:absolute;z-index:20;top:0;left:0;right:0;height:77px;box-sizing:border-box;display:flex;align-items:center;gap:12px;padding:16px 16px 16px 20px;background:#fff;border-bottom:1px solid #E7E8E8}',
    '.nk-head__txt{flex:1;min-width:0;display:flex;flex-direction:column}',
    '.nk-head__name{font-size:14px;line-height:19px;font-weight:500;color:#244545}',
    '.nk-head__role{font-size:12px;line-height:17px;color:#6D7878}',
    '.nk-head__close{flex:none;width:40px;height:40px;display:flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:transparent;color:#244545;cursor:pointer;padding:0}',
    '.nk-head__close:hover{background:#FAF8F2}',
    '.nk-av{position:relative;flex:none;display:block;width:var(--nk-av);height:var(--nk-av)}',
    '.nk-av img{display:block;width:100%;height:100%;border-radius:50%;object-fit:cover;background:#F2E9DB}',
    '.nk-away .nk-av__dot{background:#9DA5A5}',
    '.nk-av__dot{position:absolute;right:0;bottom:0;width:var(--nk-dot);height:var(--nk-dot);box-sizing:content-box;border-radius:50%;background:#34B78F;border:2px solid #fff}',
    '#conversation-floating-header,#homepage-header,[data-testid=capture-page-brand-logo]{visibility:hidden!important}',
    '[data-nk~=hidden]{display:none!important}',

    /* conversation area */
    '[data-testid=conversation-component],[data-testid=require-email-capture-component]{background:#fff!important}',
    '[data-nk~=scroll]{padding-top:77px!important;scrollbar-width:none}',
    '[data-nk~=scroll]::-webkit-scrollbar{display:none}',
    '[data-nk~=float-alt] [data-nk~=scroll]{padding-bottom:48px!important}',
    '[data-testid=status-indicator-container],article[aria-labelledby] div[aria-hidden=true]{display:none!important}',
    'article h2{align-self:center;text-align:center;font-size:10px!important;line-height:15px!important;letter-spacing:.16em!important;color:#9DA5A5!important;font-weight:500!important;text-transform:uppercase;margin:0 0 4px!important}',

    /* bubbles */
    /* design: 10px between every message; Gorgias uses 20px between sender groups and 0 inside a group */
    '[data-nk~=scroll] article:not(:has(form))>div>div{padding-top:10px!important}',
    'p.inner-content{font-size:14px!important;line-height:19px!important;font-weight:400!important;text-wrap:pretty}',
    '[data-nk~=bubble-w]{max-width:none!important}',
    '[data-nk~=bubble-u]{max-width:none!important;display:block!important}',
    ':has(>[data-nk~=bubble-u]){max-width:80%!important;margin-left:auto!important;display:flex!important;justify-content:flex-end!important}',
    /* Gorgias keeps a 40px gutter right of agent messages */
    ':has(>:has(>[data-nk~=row-w])){padding-right:0!important}',
    /* the e-mail given in the gate comes back as a visitor message: show it as the design note */
    '[data-nk~=bubble-u][data-nk~=note]{background:transparent!important;padding:4px 0!important;text-align:center!important;border-radius:0!important}',
    '[data-nk~=bubble-u][data-nk~=note] p.inner-content{color:#6D7878!important;font-size:12px!important;line-height:17px!important}',
    '[data-nk~=bubble-u][data-nk~=note] p.inner-content::before{content:"Odpowiedź wyślemy też na "}',
    ':has(>[data-nk~=note]){max-width:none!important;margin:0 auto!important;justify-content:center!important}',
    '[data-nk~=bubble-w]{background:#F9F6ED!important;color:#244545!important;border-radius:16px 16px 16px 4px!important;padding:10px 14px!important;border:0!important;box-shadow:none!important}',
    '[data-nk~=bubble-w] p.inner-content{color:#244545!important}',
    '[data-nk~=row-w]{display:flex!important;flex-direction:row!important;align-items:flex-end!important;gap:8px!important;max-width:100%!important}',
    '[data-nk~=row-w]::before{content:"";flex:none;width:28px;height:28px;border-radius:50%;background:#F2E9DB url("' + CFG.avatar + '") center/cover no-repeat}',
    '[data-nk~=bubble-u]{background:#244545!important;color:#fff!important;border-radius:16px 16px 4px 16px!important;padding:10px 14px!important;border:0!important;box-shadow:none!important}',
    '[data-nk~=bubble-u] p.inner-content,[data-nk~=bubble-u] a{color:#fff!important}',
    '[data-nk~=wrap-clear]{background:transparent!important;padding:0!important;border:0!important;box-shadow:none!important}',
    '[data-testid=agent-typing]{background:#F9F6ED!important;border-radius:16px 16px 16px 4px!important}',
    '[data-testid=typingIndicator-dot]{background:#6D7878!important}',

    /* e-mail gate (Gorgias renders it as a form inside an agent message) */
    '[data-nk~=gate]{margin-top:20px!important;border:1px solid #E7E8E8!important;border-radius:16px!important;padding:16px!important;background:#fff!important;box-shadow:none!important;display:flex!important;flex-direction:column!important;gap:12px!important;max-width:none!important;width:100%!important;box-sizing:border-box}',
    '[data-nk~=gate]>span:empty{display:none!important}',
    '.nk-gate__copy{font-size:14px!important;line-height:19px!important;color:#3C4B4B!important;margin:0!important}',
    '[data-nk~=gate] form{display:flex!important;flex-direction:column!important;gap:12px!important;margin:0!important;padding:0!important;border:0!important;background:transparent!important;box-shadow:none!important}',
    '[data-nk~=gate] form div{display:flex!important;flex-direction:column!important;gap:6px!important;padding:0!important;margin:0!important;border:0!important;background:transparent!important;box-shadow:none!important;height:auto!important;min-height:0!important;outline:0!important}',
    '[data-nk~=gate] form>div{gap:12px!important}',
    '[data-nk~=gate] label{font-size:12px!important;line-height:17px!important;color:#244545!important;font-weight:400!important}',
    '[data-nk~=gate] label .required{display:none!important}',
    '[data-nk~=gate] input:not([type=hidden]):not([type=file]),[data-nk~=gate] textarea{height:44px!important;padding:0 16px!important;border:1px solid #244545!important;border-radius:54px!important;font-size:14px!important;color:#244545!important;background:#fff!important;outline:none!important;box-shadow:none!important;box-sizing:border-box!important;width:100%!important}',
    '[data-nk~=gate] textarea{height:auto!important;min-height:88px!important;padding:12px 16px!important;border-radius:16px!important;resize:none!important}',
    '[data-nk~=gate] input::placeholder,[data-nk~=gate] textarea::placeholder{color:#9DA5A5!important}',
    '[data-nk~=gate] [aria-invalid=true]{border-color:#EF001B!important}',
    '[data-nk~=gate] input[type=email]{height:44px!important;padding:0 16px!important;border:1px solid #244545!important;border-radius:54px!important;font-size:14px!important;color:#244545!important;background:#fff!important;outline:none!important;box-shadow:none!important;box-sizing:border-box!important;width:100%!important}',
    '[data-nk~=gate] input[type=email]::placeholder{color:#9DA5A5!important}',
    '[data-nk~=gate] input[aria-invalid=true]{border-color:#EF001B!important}',
    '[data-nk~=gate] button[type=submit]{width:100%!important;height:37px!important;border:0!important;border-radius:54px!important;background:#244545!important;color:#fff!important;font-size:14px!important;letter-spacing:.6px!important;font-weight:400!important;cursor:pointer;opacity:1!important}',
    '[data-nk~=gate] button[type=submit]:hover{background:#3A5858!important}',
    '[data-nk~=gate] button[type=submit] *{color:#fff!important}',
    '[data-nk~=gate] span:has(>button[type=submit]){display:block!important;width:100%!important}',
    '.nk-gate__legal{font-size:10px!important;line-height:15px!important;color:#6D7878!important;margin:0!important}',
    '.nk-gate__legal a{color:#244545}',
    '[data-testid=privacy-notice-trigger-row]{display:none!important}',
    'button[aria-label^="Send \\""]{height:auto!important;min-height:37px!important;padding:8px 16px!important;border:1px solid #E7E8E8!important;border-radius:54px!important;background:#fff!important;color:#244545!important;font-size:14px!important;line-height:19px!important;font-weight:400!important;box-shadow:none!important}',
    'button[aria-label^="Send \\""]:hover{border-color:#244545!important;background:#FAF8F2!important}',
    'button[aria-label^="Send \\""] *{color:#244545!important;font-weight:400!important}',

    /* composer */
    ':has(>[data-testid=footer-stack]){padding:0!important;background:#fff!important}',
    '[data-testid=footer-stack]{background:#fff!important;border-top:1px solid #E7E8E8!important;padding:12px 16px 0!important;box-shadow:none!important}',
    '[data-testid=footer-component]{display:flex!important;align-items:center!important;gap:8px!important;padding:0!important;margin:0!important;background:transparent!important;box-shadow:none!important;border:0!important}',
    '[data-is-focused]{flex:1;min-width:0;display:flex!important;align-items:center!important;min-height:44px!important;box-sizing:border-box;padding:0 6px 0 16px!important;border:1px solid #E7E8E8!important;border-radius:54px!important;background:#fff!important;box-shadow:none!important;gap:4px;outline:0!important}',
    '[data-is-focused] *{background:transparent!important;border:0!important;box-shadow:none!important}',
    /* Gorgias autosizes the textarea with an inline height from a 44px min-height; size it to its content instead */
    '#chat-message-input{font-size:14px!important;line-height:19px!important;color:#244545!important;background:transparent!important;padding:0!important;border:0!important;outline:0!important;box-shadow:none!important;min-height:19px!important;max-height:96px!important;height:auto!important;field-sizing:content;resize:none!important}',
    '[data-is-focused]>div:first-child{min-height:0!important;padding:0!important;display:flex!important;align-items:center!important}',
    '#chat-message-input::placeholder{color:#9DA5A5!important;opacity:1!important}',
    /* iOS Safari zooms the whole page when a field under 16px gets focus (and stays zoomed after closing) */
    '.nk-mobile #chat-message-input,.nk-mobile [role=dialog] input:not([type=hidden]):not([type=file]),.nk-mobile [role=dialog] textarea{font-size:16px!important}',
    '.nk-mobile #chat-message-input{line-height:21px!important;min-height:21px!important}',
    '#chat-message-input-attachment-button{width:32px!important;height:32px!important;border-radius:50%!important;background:transparent!important;color:#6D7878!important;border:0!important}',
    '#chat-message-input-attachment-button{display:flex!important;align-items:center!important;justify-content:center!important}',
    '#chat-message-input-attachment-button>*{display:none!important}',
    '#chat-message-input-attachment-button::after{content:"";width:18px;height:18px;background:url("' + ICON_CLIP_URL + '") center/contain no-repeat}',
    '[data-testid=chat-input-online-indicator]{display:none!important}',
    '[data-is-focused] button[aria-label="Send message"]{display:none!important}',
    '.nk-send{flex:none;width:44px;height:44px;border-radius:50%;border:0;background:#244545;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0}',
    '.nk-send:hover{background:#3A5858}',

    /* WhatsApp / phone row */
    '.nk-chat-alt{flex:none;display:flex;justify-content:center;align-items:center;gap:14px;padding:14px 16px;font-size:12px;line-height:17px;color:#6D7878;background:#fff}',
    '.nk-chat-alt a{display:flex;align-items:center;gap:4px;white-space:nowrap;color:#244545;text-decoration:underline;text-underline-offset:3px}',
    '.nk-chat-alt a:hover{text-decoration-thickness:2px}',
    '.nk-chat-alt img{width:16px;height:16px;display:block}',
    '.nk-chat-alt--float{position:absolute;left:0;right:0;bottom:0;z-index:20}'
  ].join('\n');

  function dialogOf(doc) {
    return doc.querySelector('[role=dialog][aria-labelledby=gorgias-chat-dialog-title]');
  }

  function el(doc, tag, cls, html) {
    var n = doc.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  // Gorgias is React: it rewrites className on re-render, so its nodes get our marks as data-nk tokens.
  function mark(node, token, on) {
    var list = (node.getAttribute('data-nk') || '').split(' ').filter(Boolean);
    var i = list.indexOf(token);
    if (on === false) {
      if (i < 0) return;
      list.splice(i, 1);
    } else {
      if (i > -1) return;
      list.push(token);
    }
    node.setAttribute('data-nk', list.join(' '));
  }

  function ensureStyle(doc) {
    if (doc.getElementById('nk-chat-skin-css')) return;
    var st = el(doc, 'style');
    st.id = 'nk-chat-skin-css';
    st.textContent = IFRAME_CSS;
    (doc.head || doc.documentElement).appendChild(st);
  }

  function ensureHeader(doc, dialog) {
    if (dialog.querySelector(':scope > .nk-head')) return;
    var head = el(doc, 'div', 'nk-head',
      avatarHtml(44, 11) +
      '<div class="nk-head__txt"><div class="nk-head__name">' + NAME + '</div>' +
      '<div class="nk-head__role">' + ROLE + ' · <span class="nk-head__status">dostępna teraz</span></div></div>' +
      '<button type="button" class="nk-head__close" title="zamknij" aria-label="Zamknij czat">' + ICON_CLOSE + '</button>');
    head.querySelector('.nk-head__close').addEventListener('click', function () {
      if (api) api.close();
    });
    dialog.appendChild(head);
  }

  // Scrollable message list: push its content below our header.
  function markScroll(doc) {
    var list = doc.querySelector('[aria-label="Conversation messages"][role=region], [aria-label="Conversation messages"][role=log]:not([data-testid])');
    if (list) {
      mark(list, 'scroll');
      // Logo hero above the first message.
      list.querySelectorAll('img').forEach(function (img) {
        if (!img.closest('article') && img.parentElement && img.parentElement.parentElement) mark(img.parentElement.parentElement, 'hidden');
      });
    }
  }

  function markBubbles(doc) {
    var ps = doc.querySelectorAll('article p.inner-content');
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      var article = p.closest('article');
      var bubble = p.parentElement;
      // Live agent replies are labelled articles too, but carry a sender header (avatar + h3 name).
      var agentName = article.querySelector('h3');
      var isUser = article.hasAttribute('aria-labelledby') && !agentName;
      // The design shows agent replies like the greeting: our avatar beside the bubble, no name header.
      if (agentName) mark(agentName.parentElement, 'hidden');
      mark(bubble, 'bubble-u', isUser);
      mark(bubble, 'bubble-w', !isUser);
      mark(bubble, 'note', isUser && EMAIL_RE.test(p.textContent.trim()));
      // Gorgias paints the bubble on a wrapper; neutralise wrappers between the bubble and the row.
      var w = bubble.parentElement;
      while (w && w !== article && !w.querySelector(':scope > [data-testid=status-indicator-container]')) {
        if (!isUser && w.tagName === 'SPAN') { mark(w.parentElement, 'row-w'); break; }
        mark(w, 'wrap-clear');
        w = w.parentElement;
      }
    }
  }

  // Every form Gorgias renders inside a message (the e-mail gate, the offline contact form steps) gets the card look.
  function enhanceForms(doc) {
    doc.querySelectorAll('article form').forEach(function (form) {
      var card = form.parentElement;
      mark(card, 'gate');
      var w = card.parentElement;
      while (w && w.tagName !== 'ARTICLE') { mark(w, 'wrap-clear'); w = w.parentElement; }
    });
  }

  function enhanceGate(doc) {
    var input = doc.getElementById('email-field-capture');
    if (!input) return;
    var form = input.closest('form');
    if (!form) return;
    var card = form.parentElement;
    // The design copy belongs to the "required e-mail" gate only, not to the offline contact form.
    if (input.closest('article#emailCaptureAgentAsking') && !card.querySelector(':scope > .nk-gate__copy')) {
      card.insertBefore(el(doc, 'p', 'nk-gate__copy', GATE_COPY), form);
    }
    if (!card.querySelector(':scope > .nk-gate__legal')) {
      card.appendChild(el(doc, 'p', 'nk-gate__legal',
        'Wysyłając, akceptujesz <a href="' + esc(CFG.privacyUrl || '/policies/privacy-policy') + '" target="_blank" rel="noopener">politykę prywatności</a>.'));
    }
    var label = form.querySelector('label[for=email-field-capture]');
    if (label && label.firstChild && label.firstChild.nodeType === 3 && label.firstChild.nodeValue !== 'E-mail') label.firstChild.nodeValue = 'E-mail';
    if (input.getAttribute('placeholder') !== 'twoj@email.pl') input.setAttribute('placeholder', 'twoj@email.pl');
    var submit = form.querySelector('button[type=submit]');
    if (submit && input.closest('article#emailCaptureAgentAsking') && submit.textContent !== 'Rozpocznij rozmowę') {
      var walker = doc.createTreeWalker(submit, NodeFilter.SHOW_TEXT, null);
      var t = walker.nextNode();
      if (t) t.nodeValue = 'Rozpocznij rozmowę';
    }
  }

  function enhanceComposer(doc) {
    var ta = doc.getElementById('chat-message-input');
    if (!ta) return;
    var footer = ta.closest('[data-testid=footer-component]');
    // The native bar is styled as the pill; only add our round send button after it (never move React nodes).
    if (!footer || footer.querySelector(':scope > .nk-send')) return;
    var send = el(doc, 'button', 'nk-send', ICON_ARROW.replace('width="16" height="16"', 'width="18" height="18"'));
    send.type = 'button';
    send.title = 'wyślij';
    send.setAttribute('aria-label', 'Wyślij wiadomość');
    send.addEventListener('click', function () {
      var area = doc.getElementById('chat-message-input');
      if (!area || !area.value.trim()) return;
      // Gorgias renders its own (hidden by us) send button once there is text; prefer it, Enter as fallback.
      var native = footer.querySelector('[data-is-focused] button[aria-label="Send message"]');
      if (native) return native.click();
      area.focus();
      ['keydown', 'keypress'].forEach(function (type) {
        area.dispatchEvent(new KeyboardEvent(type, { key: 'Enter', code: 'Enter', keyCode: 13, which: 13, charCode: type === 'keypress' ? 13 : 0, bubbles: true, cancelable: true }));
      });
    });
    footer.appendChild(send);
  }

  function ensureAltRow(doc, dialog) {
    var stack = doc.querySelector('[data-testid=footer-stack]');
    var row = doc.querySelector('.nk-chat-alt');
    var compact = MOBILE_MQ.matches;
    if (stack) {
      if (!row || row.parentElement !== stack.parentElement || row.previousElementSibling !== stack) {
        if (row) row.remove();
        row = el(doc, 'div', 'nk-chat-alt', altLinksHtml(compact));
        stack.parentElement.insertBefore(row, stack.nextSibling);
      }
      row.classList.remove('nk-chat-alt--float');
    } else if (!row) {
      row = el(doc, 'div', 'nk-chat-alt nk-chat-alt--float', altLinksHtml(compact));
      dialog.appendChild(row);
    }
    mark(dialog, 'float-alt', !stack);
  }

  // Outside business hours the header must not promise "dostępna teraz".
  function markAway(doc) {
    var head = doc.querySelector('.nk-head');
    if (!head || !api || typeof api.isChatOnline !== 'function') return;
    var away = !api.isChatOnline();
    head.classList.toggle('nk-away', away);
    var status = head.querySelector('.nk-head__status');
    var text = away ? 'odpowiem w godzinach pracy' : 'dostępna teraz';
    if (status && status.textContent !== text) status.textContent = text;
  }

  function patchTexts(doc) {
    var walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue.trim();
      if (TEXT_MAP[v]) node.nodeValue = node.nodeValue.replace(v, TEXT_MAP[v]);
      else if (WEEKDAY_RE.test(v)) node.nodeValue = node.nodeValue.replace(WEEKDAY_RE, function (all, pre, day) { return WEEKDAYS_PL[day]; });
      else if (node.parentElement && node.parentElement.tagName === 'H2' && node.parentElement.closest('article')) {
        var pl = plDate(v);
        if (pl) node.nodeValue = pl;
      }
    }
    Object.keys(PLACEHOLDER_MAP).forEach(function (from) {
      doc.querySelectorAll('[placeholder="' + from + '"]').forEach(function (n) { n.setAttribute('placeholder', PLACEHOLDER_MAP[from]); });
    });
  }

  var TEXT_MAP = { 'Submit': 'Wyślij', 'Email is required': 'Adres e-mail jest wymagany', 'Today': 'Dziś', 'Yesterday': 'Wczoraj', 'Email': 'E-mail', 'Subject': 'Temat', 'Message': 'Wiadomość', 'Name': 'Imię', 'Send': 'Wyślij' };
  // Gorgias formats {weekday} in English; backLabelBackOn is set to "Wrócimy {weekday}".
  var WEEKDAY_RE = /(^|\s)w (Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)\b/;
  var WEEKDAYS_PL = { Monday: ' w poniedziałek', Tuesday: ' we wtorek', Wednesday: ' w środę', Thursday: ' w czwartek', Friday: ' w piątek', Saturday: ' w sobotę', Sunday: ' w niedzielę' };
  var PLACEHOLDER_MAP = { 'your@email.com': 'twoj@email.pl', 'Reply': 'Napisz wiadomość' };
  var MONTHS_EN = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var MONTHS_PL = ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'];

  // Date separators come as "MMMM D" in English regardless of the widget language.
  function plDate(v) {
    var m = /^([A-Z][a-z]+) (\d{1,2})(?:, (\d{4}))?$/.exec(v);
    if (!m) return null;
    var mi = MONTHS_EN.indexOf(m[1]);
    if (mi < 0) return null;
    var now = new Date();
    if (mi === now.getMonth() && +m[2] === now.getDate() && (!m[3] || +m[3] === now.getFullYear())) return 'Dziś';
    return m[2] + ' ' + MONTHS_PL[mi] + (m[3] ? ' ' + m[3] : '');
  }

  // The design opens straight into the conversation: skip the self-service homepage by pressing its
  // only pill button ("Wyślij wiadomość" for new visitors, "Zobacz poprzednią konwersację" for returning ones).
  function skipHome(doc, dialog) {
    var home = doc.getElementById('homepage-header');
    var btn = home && doc.querySelector('#self-service-portal-container button[shape=pill]');
    // Without the button there is nothing to skip to, so never leave the panel hidden.
    mark(dialog, 'home', !!btn);
    if (!btn) {
      doc.nkHomeSkippedAt = 0;
      doc.nkHomeTries = 0;
      return;
    }
    // Gorgias returns to the homepage after close/reopen (often the same button node), so retry
    // whenever it is back; the throttle only guards against clicking twice during the transition.
    var now = Date.now();
    if (now - (doc.nkHomeSkippedAt || 0) < 1000) return;
    if ((doc.nkHomeTries || 0) >= 5) return mark(dialog, 'home', false);
    doc.nkHomeSkippedAt = now;
    doc.nkHomeTries = (doc.nkHomeTries || 0) + 1;
    btn.click();
    setTimeout(function () { skin(doc); }, 1100);
  }

  // iOS Safari only scrolls the field above the keyboard once the caret moves (first typed character),
  // so after focus the view sits on the header. Move the caret ourselves once the keyboard is up.
  function revealCaretOnFocus(doc) {
    if (doc.nkCaretReveal) return;
    doc.nkCaretReveal = true;
    doc.addEventListener('focusin', function (e) {
      var f = e.target;
      if (!doc.documentElement.classList.contains('nk-mobile')) return;
      if (!f.matches || !f.matches('textarea, input[type=text], input[type=email], input:not([type])')) return;
      [300, 600].forEach(function (ms) {
        setTimeout(function () {
          if (doc.activeElement !== f) return;
          try { var end = f.value.length; f.setSelectionRange(end, end); } catch (err) { /* type=email has no selection API */ }
        }, ms);
      });
    });
  }

  function skin(doc) {
    var dialog = dialogOf(doc);
    if (!dialog) return;
    doc.documentElement.classList.toggle('nk-mobile', MOBILE_MQ.matches);
    ensureStyle(doc);
    revealCaretOnFocus(doc);
    skipHome(doc, dialog);
    ensureHeader(doc, dialog);
    markScroll(doc);
    markBubbles(doc);
    enhanceForms(doc);
    enhanceGate(doc);
    markAway(doc);
    enhanceComposer(doc);
    ensureAltRow(doc, dialog);
    patchTexts(doc);
  }

  function attachWindow(iframe) {
    if (iframe.dataset.nkSkin) return;
    iframe.dataset.nkSkin = '1';
    var scheduled = false;
    function run() {
      var doc;
      try { doc = iframe.contentDocument; } catch (e) { return; }
      if (!doc || !doc.body) return;
      skin(doc);
      if (doc.body.dataset.nkObserved) return;
      doc.body.dataset.nkObserved = '1';
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        setTimeout(function () { scheduled = false; skin(doc); }, 16);
      }).observe(doc.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['placeholder', 'class'] });
    }
    run();
    iframe.addEventListener('load', run);
  }

  // Campaigns iframe: Polish copy + campaign message handed over to our invitation card.
  function attachTextOnly(iframe) {
    if (iframe.dataset.nkText) return;
    iframe.dataset.nkText = '1';
    function run() {
      var doc;
      try { doc = iframe.contentDocument; } catch (e) { return; }
      if (!doc || !doc.body) return;
      patchTexts(doc);
      syncCampaign(doc);
      new MutationObserver(function () { patchTexts(doc); syncCampaign(doc); })
        .observe(doc.body, { childList: true, subtree: true, characterData: true });
    }
    run();
    iframe.addEventListener('load', run);
  }

  function scanIframes() {
    var w = document.getElementById('chat-window');
    if (w) attachWindow(w);
    var c = document.getElementById('chat-campaigns');
    if (c) attachTextOnly(c);
  }

  /* ---------------------------------------------------------------- Gorgias API */

  // Self-service / AI agent / order tracking copy: Gorgias ships it in English; the shop's own PL keys are left out.
  var SSP_TEXTS_PL = {
    reasonItemsMissingDefaultResponse: "Bardzo nam przykro. Kliknij „Potrzebujesz więcej pomocy?” i napisz, których produktów brakuje w przesyłce.",
    aiAgentAuthenticationFailed: "Nie udało się zalogować.",
    aiAgentAuthenticationSuccess: "Zalogowano pomyślnie.",
    aiDidntSolveIssue: "Nie pomogło rozwiązać mojego problemu",
    aiInaccurateInfo: "Nieprawdziwe informacje",
    aiUnsatisfactoryOutcome: "Wynik mnie nie zadowala",
    aiConfusingResponse: "Niejasna odpowiedź",
    aiPoweredConversation: "Wspierane przez AI, by szybciej Ci pomóc",
    alreadySignedIn: "Już zalogowano",
    answerThatMayHelp: "Znalazłam odpowiedź, która może Ci pomóc!",
    applyPromoCode: "Użyj kodu rabatowego",
    april: "kwi",
    articleRecommendationInputPlaceholder: "Potrzebujesz więcej pomocy? Zadaj nam pytanie!",
    articleThatMayHelp: "Oto artykuł, który może Ci pomóc:",
    imLookingFor: "Szukam...",
    attachUpToFiles: "Załącz maks. {number} plików",
    attemptedDelivery: "Próba doręczenia",
    august: "sie",
    awaitingFulfillment: "Oczekuje na realizację",
    awaitingPayment: "Oczekuje na płatność",
    backToHome: "Wróć do początku",
    home: "Start",
    billingInformation: "Dane do faktury",
    cancel: "Anuluj",
    canceled: "Anulowane",
    cancelFulfillment: "Anuluj realizację",
    cancelled: "Anulowane",
    cancelMessageDescription: "Chcę anulować realizację tej przesyłki",
    cancelOrder: "Anuluj zamówienie",
    cantSignIn: "Nie możesz się zalogować?",
    change: "Zmień",
    changeShippingAddress: "Chcę zmienić adres dostawy",
    checkEmail: "Sprawdź skrzynkę e-mail",
    checkpointAttemptFail: "Nieudana próba",
    checkpointAvailableForPickup: "Gotowa do odbioru",
    checkpointDelayed: "Opóźniona",
    checkpointDelivered: "Doręczona",
    checkpointException: "Problem z przesyłką",
    checkpointException_001: "Problem z przesyłką",
    checkpointException_002: "Zmiana adresu odbiorcy",
    checkpointException_003: "Odbiorca odmówił przyjęcia",
    checkpointException_004: "Opóźniona (odprawa celna)",
    checkpointException_005: "Opóźniona (czynniki zewnętrzne)",
    checkpointException_006: "Wstrzymana do czasu płatności",
    checkpointException_007: "Nieprawidłowy adres",
    checkpointException_008: "Nieodebrana",
    checkpointException_009: "Odrzucona przez przewoźnika",
    checkpointException_010: "W drodze do nadawcy",
    checkpointException_011: "Zwrócona do nadawcy",
    checkpointException_012: "Uszkodzona przesyłka",
    checkpointException_013: "Zagubiona przesyłka",
    checkpointExpired: "Wygasła",
    checkpointInfoReceived: "Dane przesyłki otrzymane",
    checkpointInTransit: "W drodze",
    checkpointOrderPlaced: "Zamówienie złożone",
    checkpointOutForDelivery: "Wydana do doręczenia",
    checkpointPending: "Oczekuje",
    checkpointPickedUp: "Odebrana",
    checkSpamFolder: "Jeśli nie widzisz wiadomości z kodem, sprawdź folder spam i oferty.",
    codeAutoSubmitHelpText: "Formularz wyśle się automatycznie po wpisaniu wszystkich 6 cyfr",
    codeExpiresIn: "Kod wygaśnie za",
    codeSentTo: "Kod wysłany na",
    codeWillExpire: "Ten kod wygaśnie za 10 minut. Jeśli to nie Ty prosisz o kod, daj nam znać.",
    completed: "Zakończone",
    completeReturnDeepLink: "Dokończ zwrot w naszym portalu zwrotów",
    confirmed: "Potwierdzone",
    confirmOrder: "Potwierdź zamówienie",
    continue: "Dalej",
    continueToSignIn: "Przejdź do logowania",
    createdAt: "Utworzono",
    customerHasNoOrdersEmail: "Brak zamówień dla tego adresu e-mail",
    customerHasNoOrdersPhone: "Brak zamówień dla tego numeru telefonu",
    damagedInDelivery: "Moje zamówienie zostało uszkodzone w transporcie",
    december: "gru",
    delivered: "Doręczone",
    deliveredAt: "o",
    deliveredOn: "Doręczono",
    deliveredVia: "Wysłano przez",
    discountCodeCtaCopied: "Kod skopiowany!",
    discountCodeCtaDescription: "Użyj kodu w koszyku, aby otrzymać {discountRate}% rabatu, ważny przez {validityInHours} h",
    editOrder: "Edytuj zamówienie",
    email: "E-mail",
    errorFetchingOrders: "Wystąpił błąd podczas pobierania Twoich zamówień",
    errorGeneratingReturnPortalLink: "Wystąpił błąd podczas tworzenia linku do portalu zwrotów",
    errorProcessingMessage: "Nie udało się przetworzyć Twojej wiadomości, ale ją zapisałam i odpowiemy Ci e-mailem",
    errorSendingReportIssue: "Coś poszło nie tak podczas wysyłania zgłoszenia.",
    estimatedDelivery: "Przewidywana dostawa",
    etaProvidedBy: "Termin podany przez",
    expectToBeDeliveredBy: "do",
    failedDelivery: "Nieudane doręczenie",
    failedFulfillment: "Nieudana realizacja",
    failure: "Błąd",
    february: "lut",
    feedbackSubmitted: "Dziękuję za Twoją opinię!",
    fillYourEmailToTalkToAnAgent: "Zostaw nam swój e-mail",
    findOrder: "Znajdź swoje zamówienie",
    fulfillment: "Realizacja",
    fulfillmentDetails: "Szczegóły realizacji",
    goBack: "Wróć",
    goToCheckoutButtonLabel: "Przejdź do kasy",
    goToReturnPortal: "Przejdź do portalu zwrotów",
    happyToHelp: "Cieszę się, że mogłam pomóc. Miłego dnia!",
    hi: "Cześć,",
    hiFirstname: "Cześć {{firstName}},",
    howCanIHelp: "Jak możemy Ci pomóc?",
    iHaveTheFollowingIssue: "Mam następujący problem:",
    incorrectOrder: "Otrzymane zamówienie jest nieprawidłowe",
    inTransit: "W drodze",
    inTransitVia: "W drodze z",
    invalidCode: "Nieprawidłowy kod",
    invalidCustomerEmail: "Nie znaleziono klienta ani zamówień dla tego adresu e-mail",
    invalidCustomerPhone: "Nie znaleziono klienta ani zamówień dla tego numeru telefonu",
    invalidEmail: "Nieprawidłowy e-mail",
    invalidPhoneNumber: "Nieprawidłowy numer telefonu",
    isThisTheCorrectOrder: "Czy to właściwe zamówienie?",
    itemNames: "Nazwy produktów",
    itemsRequestedForReturn: "Produkty do zwrotu",
    iWouldLikeToCancelTheFollowingOrder: "Chcę anulować to zamówienie",
    iWouldLikeToReturnTheFollowingItems: "Chcę zwrócić te produkty",
    january: "sty",
    july: "lip",
    june: "cze",
    labelPrinted: "Etykieta wydrukowana",
    labelPurchased: "Etykieta zakupiona",
    lastUpdated: "Ostatnia aktualizacja",
    learnMore: "Dowiedz się więcej",
    lostOrderDetails: "Nie masz danych zamówienia? Porozmawiaj z nami",
    manageMyOrders: "Zarządzaj zamówieniami",
    manageYourOrders: "Zarządzaj swoimi zamówieniami",
    march: "mar",
    maxVerificationAttemptsReached: "Wykorzystano limit prób weryfikacji",
    may: "maj",
    myItems: "Moje produkty",
    myOrders: "Moje zamówienia",
    needHelp: "Potrzebujesz więcej pomocy?",
    needMoreHelp: "Potrzebujesz więcej pomocy?",
    noContinueToSignIn: "Nie, przejdź do logowania",
    noCustomerAssociatedEmail: "Brak klienta przypisanego do tego adresu e-mail",
    noCustomerAssociatedPhone: "Brak klienta przypisanego do tego numeru telefonu",
    noINeedMoreHelp: "Nie, potrzebuję więcej pomocy",
    notRelevantRequestAnAgent: "To nie to, chcę porozmawiać z kimś z zespołu",
    november: "lis",
    numberOfItemSelectedLabel: "Wybrano {count} produkt",
    numberOfItemsSelectedLabel: "Wybrano produkty: {count}",
    october: "paź",
    of: "z",
    offlineMessage: "Brak połączenia. Łączę ponownie...",
    oneItemSelected: "Wybrano 1 produkt",
    onHold: "Wstrzymane",
    or: "lub",
    order: "Zamówienie",
    orderCreated: "Zamówienie utworzone",
    orderNumber: "Numer zamówienia",
    orderPending: "Zamówienie oczekuje",
    orderItemCountOne: "1 produkt",
    orderItemCountMany: "Produkty: {count}",
    orderItemsRemainingOne: "i 1 więcej",
    orderItemsRemainingMany: "i {count} więcej",
    orderPlaced: "Zamówienie złożone",
    orders: "zamówienia",
    trackOrders: "Śledź zamówienia",
    other: "Inne",
    outForDelivery: "Wydane do doręczenia",
    outForDeliveryVia: "Wydane do doręczenia przez",
    partiallyFulfilled: "Częściowo zrealizowane",
    partiallyRefunded: "Częściowo zwrócone",
    pastDeliveryDate: "Minął przewidywany termin dostawy",
    payment: "Płatność",
    pendingDelivery: "Oczekuje na doręczenie",
    pleaseRefreshPageToUseChat: "Odśwież stronę, aby dalej korzystać z czatu.",
    pleaseUseVerificationCodeToLogIn: "Użyj tego kodu weryfikacyjnego, aby dokończyć logowanie:",
    previousConversation: "Przejdź do poprzedniej rozmowy",
    processing: "W realizacji",
    processingFulfillment: "Realizacja w toku",
    provideEmailAndOrderNumber: "Podaj adres e-mail i numer zamówienia",
    price: "Cena",
    quantity: "ilość",
    quantityToReturn: "Ilość do zwrotu",
    quickAnswers: "Szybkie odpowiedzi",
    readyForPickup: "Gotowe do odbioru",
    reasonCancelOrder: "Chcę anulować zamówienie",
    reasonCancelOrderDefaultResponse: "Niestety nie możemy obecnie zmieniać już złożonych zamówień.",
    reasonCancelSubscription: "Chcę anulować subskrypcję",
    reasonCancelSubscriptionDefaultResponse: "Dziękuję za wiadomość w sprawie subskrypcji. Wkrótce wrócimy do Ciebie z kolejnymi krokami.",
    reasonChangeDeliveryDate: "Chcę zmienić termin dostawy",
    reasonChangeDeliveryDateDefaultResponse: "Niestety nie możemy obecnie zmieniać już złożonych zamówień.",
    reasonChangeShippingAddress: "Chcę zmienić adres dostawy",
    reasonChangeShippingAddressDefaultResponse: "Niestety nie możemy obecnie zmieniać już złożonych zamówień.",
    reasonDidNotReceiveRefund: "Zwrot pieniędzy do mnie nie dotarł",
    reasonDidNotReceiveRefundDefaultResponse: "Zwrot pieniędzy został zlecony na pierwotną metodę płatności. Zaksięgowanie środków na Twoim koncie może potrwać do 5 dni roboczych.\r\\n\r\\nJeśli minęło już ponad 5 dni roboczych, daj nam znać, że potrzebujesz pomocy.",
    reasonDiscountNotWorking: "Mój kod rabatowy nie działa",
    reasonDiscountNotWorkingDefaultResponse: "Dziękuję za wiadomość. Wkrótce ktoś z naszego zespołu pomoże Ci z kodem rabatowym.",
    reasonEditOrder: "Chcę zmienić zamówienie",
    reasonEditOrderDefaultResponse: "Niestety nie możemy obecnie zmieniać już złożonych zamówień.",
    reasonEditSubscription: "Chcę zmienić subskrypcję",
    reasonEditSubscriptionDefaultResponse: "Dziękuję za wiadomość w sprawie subskrypcji. Wkrótce wrócimy do Ciebie z kolejnymi krokami.",
    reasonExchangeRequest: "Chcę wymienić produkty z zamówienia",
    reasonForgotToUseDiscount: "Kod rabatowy nie został użyty przy zamówieniu",
    reasonForgotToUseDiscountDefaultResponse: "Podaj kod rabatowy, którego nie udało się użyć, a sprawdzę to dla Ciebie.",
    reasonIncorrectItems: "Produkty różnią się od zamówionych",
    reasonIncorrectItemsDefaultResponse: "Bardzo mi przykro. Napisz proszę, jaki dokładnie produkt (wariant/rozmiar) do Ciebie dotarł.",
    reasonItemsMissing: "W zamówieniu brakuje produktów",
    reasonNotHappy: "Produkt nie spełnił moich oczekiwań 👎",
    reasonNotHappyDefaultResponse: "Przykro mi to słyszeć. Czy możemy coś zrobić, żeby Twoje doświadczenie z nami było lepsze?",
    reasonOrderDamaged: "Moje zamówienie zostało uszkodzone w transporcie",
    reasonOrderDamagedDefaultResponse: "Bardzo mi przykro. Opisz proszę dokładniej uszkodzenie produktów i daj znać, czy karton wysyłkowy też był uszkodzony.",
    reasonOrderDefective: "Produkty w moim zamówieniu są wadliwe",
    reasonOrderDefectiveDefaultResponse: "Bardzo mi przykro. Opisz proszę dokładniej wadę, którą zauważono.",
    reasonOrderStillNotShipped: "Moje zamówienie powinno być już wysłane",
    reasonOrderStillNotShippedDefaultResponse: "Ze względu na dużą liczbę przesyłek dostawa może się opóźnić. Numer do śledzenia przesyłki powinien pojawić się w ciągu kolejnego dnia roboczego.",
    reasonOrderStuckInTransit: "Moja przesyłka utknęła w drodze",
    reasonOrderStuckInTransitDefaultResponse: "Bardzo mi przykro. Wkrótce ktoś z naszego zespołu pomoże Ci rozwiązać ten problem.",
    reasonOther: "Inne",
    reasonOtherDefaultResponse: "Jak możemy Ci pomóc?",
    reasonPastExpectedDeliveryDate: "Minął przewidywany termin dostawy",
    reasonPastExpectedDeliveryDateDefaultResponse: "Ze względu na dużą liczbę przesyłek dostawa może się opóźnić. Daj przesyłce jeszcze kilka dni roboczych na dotarcie do Ciebie.",
    reasonReorderItems: "Chcę ponownie zamówić produkty",
    reasonReorderItemsDefaultResponse: "Chętnie pomogę! Co chcesz zamówić ponownie?",
    reasonReplaceItemsRequest: "Chcę wymienić produkty z zamówienia",
    reasonRequestDiscount: "Chcę otrzymać kod rabatowy",
    reasonRequestDiscountDefaultResponse: "Dziękuję za wiadomość. W tej chwili nie mamy kodów rabatowych do przekazania.",
    reasonRequestRefund: "Chcę otrzymać zwrot pieniędzy za to zamówienie",
    reasonRequestRefundDefaultResponse: "Jeśli Twoje konto zostało obciążone, zwrot pieniędzy został zlecony na pierwotną metodę płatności w chwili anulowania zamówienia. Zaksięgowanie środków na Twoim koncie może potrwać do 5 dni roboczych.",
    reasonReturnProduct: "Chcę zwrócić produkt",
    reasonVeryHappy: "Produkt bardzo mi się podoba 👍",
    reasonVeryHappyDefaultResponse: "Dziękuję za miłe słowa! Chętnie dowiem się, co najbardziej podoba Ci się w naszych produktach.",
    reasonWhereIsMyOrder: "Gdzie jest moje zamówienie?",
    receiveByEmail: "Otrzymaj odpowiedź e-mailem",
    refunded: "Zwrócone",
    reportAnIssueWithOrder: "Zgłoś problem",
    reportIssue: "Zgłoś problem",
    requestCancellation: "Poproś o anulowanie",
    requestReturn: "Poproś o zwrot",
    resendCode: "Wyślij kod ponownie",
    retry: "Spróbuj ponownie",
    return: "Zwrot",
    returnItems: "Zwróć produkty",
    returnOrder: "Zwróć zamówienie",
    returnOrderShort: "Zwróć zamówienie",
    scheduled: "Zaplanowane",
    see1MoreItem: "1 produkt więcej",
    see1MoreOrder: "Pokaż 1 zamówienie więcej",
    seeItems: "Pokaż produkty",
    seeMoreItems: "Więcej produktów: {moreItemsCount}",
    seeMoreOrders: "Pokaż więcej zamówień: {nextPageOrderCount}",
    seeOrders: "Zobacz swoje zamówienia",
    selectAll: "Zaznacz wszystko",
    selectedItem: "Wybrany produkt",
    selectedItems: "Wybrane produkty",
    selectItems: "Wybierz produkty",
    sendCode: "Wyślij kod",
    sent: "Wysłane",
    september: "wrz",
    severalItemsSelected: "Wybrano produkty: {itemsSelectedCount}",
    shipment: "Przesyłka",
    shipmentBeingDelivered: "Przesyłka jest w drodze do miejsca docelowego.",
    shipping: "Dostawa",
    shippingAddress: "Adres dostawy",
    shippingInformation: "Informacje o dostawie",
    showLessItems: "Pokaż mniej",
    showAllItems: "Pokaż wszystko",
    signedWith: "Zalogowano jako",
    signIn: "Zaloguj się",
    signInDifferentAccount: "Zaloguj się na inne konto",
    signInEmail: "Zaloguj się e-mailem",
    signInPhone: "Zaloguj się numerem telefonu",
    signInToAccessOrders: "Aby kontynuować, zaloguj się i zobacz swoje zamówienia.",
    signInToContinue: "Zaloguj się, aby kontynuować",
    signInWithOrderNumber: "Zaloguj się numerem zamówienia",
    signOut: "Wyloguj się",
    sincerely: "Pozdrawiamy serdecznie,",
    sms: "SMS",
    sorryToHearThatEmailNotRequired: "Łączę Cię z naszym zespołem. Wkrótce się odezwiemy.",
    sorryToHearThatEmailRequired: "Podaj swój e-mail, aby połączyć się z naszym zespołem.",
    sorryToHearThatHandoverToLiveChatFewHours: "Łączę Cię z naszym zespołem. Odezwiemy się w ciągu kilku godzin.",
    sorryToHearThatHandoverToLiveChatFewMinutes: "Łączę Cię z naszym zespołem. Odezwiemy się w ciągu kilku minut.",
    startConversation: "Rozpocznij rozmowę",
    stayInChat: "Zostań na czacie",
    stuckInTransit: "Moja przesyłka od kilku dni stoi w miejscu",
    subtotal: "Suma częściowa (z VAT)",
    summary: "Podsumowanie",
    supportTeam: "Zespół obsługi klienta {{shopFriendlyName}}",
    talkToLiveAgent: "porozmawiaj z nami",
    thanksOurTeamWillRespond: "Dziękuję, nasz zespół wkrótce odpowie.",
    total: "Razem",
    track: "Śledź",
    trackAndManageMyOrders: "Śledź zamówienia i zarządzaj nimi",
    tracking: "Śledzenie",
    trackingNumber: "Numer przesyłki",
    trackingNumberPrefix: "Nr przesyłki",
    trackingUrl: "Link do śledzenia",
    trackOrder: "Śledź przesyłkę",
    trackOrderSentVia: "Wysłano przez {trackingCompany}",
    trySigningInWithOrderNumber: "Spróbuj zalogować się numerem zamówienia",
    unavailable: "Niedostępne",
    unfulfilled: "Niezrealizowane",
    verificationCodeField: "6-cyfrowy kod",
    wasThatHelpful: "Czy to było pomocne?",
    wasThisHelpful: "Czy to było pomocne?",
    wasThisRelevant: "Czy to odpowiada na Twoje pytanie?",
    whatIsWrongWithOrder: "Co jest nie tak z Twoim zamówieniem?",
    yesCloseMyRequest: "Tak, zamknij zgłoszenie",
    yesThanks: "Tak, dzięki",
    yesThankYou: "Tak, dziękuję",
    yourEmail: "Twój e-mail",
    yourOrders: "Twoje zamówienia",
    yourPhoneNumber: "Twój numer telefonu",
    youWillGetRepliesByEmail: "Dziękuję! Odpowiedź otrzymasz e-mailem.",
    emailCaptureTriggerTypicalReplyMinutes: "Dziękuję za wiadomość! Odezwiemy się w ciągu kilku minut.",
    enterCode: "Wpisz kod wysłany na",
    emailCaptureTriggerTypicalReplyHours: "Dziękuję za wiadomość! Odezwiemy się w ciągu kilku godzin.",
    verifyOrderDetails: "Zweryfikuj dane zamówienia",
    aiAgentAnalyzing: "Już sprawdzam",
    aiAgentThinking: "Sprawdzam to dla Ciebie",
    aiAgentGatheringDetails: "Chwileczkę",
    aiAgentAlmostThere: "Prawie gotowe",
    aiAgentReasoningHandover: "Łączę Cię z osobą z zespołu",
    aiAgentReasoningLookingUp: "Sprawdzam to dla Ciebie",
    aiAgentReasoningSearchingProducts: "Szukam produktów",
    aiAgentReasoningSearchingProductsAndDiscounts: "Szukam produktów i rabatów",
    aiAgentReasoningProductDetails: "Sprawdzam szczegóły produktu",
    aiAgentReasoningSearchingProductsWithPreview: "Zbieram produkty",
    aiAgentReasoningSearchingProductsAndDiscountsWithPreview: "Szukam okazji",
    aiAgentReasoningProductDetailsWithPreview: "Pobieram szczegóły",
    aiAgentReasoningOrderDetails: "Sprawdzam szczegóły zamówienia",
    supportAgentJoining: "Osoba z naszego zespołu dołącza do czatu",
    supportAgentAdditionalQuestions: "Śmiało zadawaj kolejne pytania — nasz zespół odpowie, gdy tylko dołączy.",
    supportAgentAdditionalQuestionsChatRedesignSoon: "Chcesz coś dodać? Nasz zespół wkrótce dołączy",
    supportAgentAdditionalQuestionsChatRedesignMinutes: "Chcesz coś dodać? Nasz zespół dołączy za {{minutes}} min",
    supportAgentAdditionalQuestionsChatRedesignMoreThan: "Chcesz coś dodać? Nasz zespół dołączy za ponad 15 min",
    supportAgentJoined: "{{name}} dołącza do czatu",
    fileExtensionNotSupported: "Jeden z plików ma nieobsługiwane rozszerzenie"
  };

  function configure(chat) {
    api = chat;
    try {
      chat.updateTexts({
        requireEmailCaptureIntro: GREETING,
        emailCaptureInputLabel: 'E-mail',
        emailCapturePlaceholder: 'twoj@email.pl',
        emailCaptureOnlineThanksText: 'Odpowiedź wyślemy też na {email}',
        emailCaptureThanksText: 'Odpowiedź wyślemy też na {email}',
        inputReplyPlaceholder: 'Napisz wiadomość',
        inputPlaceholder: 'Napisz wiadomość',
        campaignClickToReply: 'Kliknij, aby odpowiedzieć',
        shopClosingSoon: '{shopName} zamyka się za {minutes} minut.',
        backLabelBackAt: 'Wrócimy tu jutro o {time}',
        backLabelBackInAMinute: 'Wrócimy za minutę',
        backLabelBackInAnHour: 'Wrócimy za godzinę',
        backLabelBackInDays: 'Wrócimy za {value} dni',
        backLabelBackInHours: 'Wrócimy za {value} godz.',
        backLabelBackInMinutes: 'Wrócimy za {value} min',
        backLabelBackOn: 'Wrócimy w {weekday}',
        backLabelBackTomorrow: 'Wrócimy wkrótce',
        actionPostbackError: 'Coś poszło nie tak. Spróbuj ponownie.',
        aiAgentHandoverFallbackMessage: 'Zostaw swój adres e-mail, a odpowiemy najszybciej, jak to możliwe.',
        cannotUploadMoreFiles: 'Możesz dodać maksymalnie {maxFilesPerUpload} plików naraz.',
        close: 'Zamknij',
        contactFormEndingMessageWithHelpCenter: 'Dziękujemy za wiadomość, odpowiemy e-mailem wkrótce.',
        contactFormIntroWithEmail: 'Dziękujemy za kontakt! Zostaw e-mail, a odpowiemy, gdy tylko będziemy dostępni.',
        contactFormSSPUnsuccessfulAskAdditionalMessage: 'Dziękujemy za kontakt. Zostaw wiadomość, a odpowiemy e-mailem, gdy wrócimy.',
        emailCaptureBeginningIntro: 'Podaj e-mail, żebym mogła odpowiedzieć także wtedy, gdy zamkniesz to okno.',
        emailCaptureOfflineThanksText: 'Dziękujemy! Odpowiedź wyślemy na {email}.',
        emailCaptureOfflineTriggerText: 'Jesteśmy teraz niedostępni. Zostaw e-mail, a odpowiemy najszybciej, jak to możliwe.',
        emailCaptureOnlineTriggerText: 'Zostaw e-mail, a odpowiemy wkrótce.',
        emailCaptureRequiredEmailPlaceholder: 'twoj@email.pl',
        emailCaptureRequiredMessagePlaceholder: 'Napisz wiadomość',
        emailCaptureTriggerBackOnlineAt: 'Wrócimy o {time}',
        emailCaptureTriggerBackOnlineOn: 'Wrócimy w {weekday}',
        emailCaptureTriggerTextBase: 'Zostaw e-mail, a odpowiemy.',
        howCanWeHelpToday: 'W czym mogę pomóc?',
        invalidFileError: 'Obsługujemy tylko zdjęcia (jpg, jpeg, png, gif, bmp).',
        leaveAnotherMessage: 'Zostaw kolejną wiadomość',
        messageError: 'Nie udało się wysłać wiadomości. Spróbuj ponownie.',
        messageIndicatorTitleSingular: '({count}) Nowa wiadomość',
        messageNotDelivered: 'Wiadomość nie została dostarczona.',
        seePreviousMessage: 'Zobacz poprzednią wiadomość',
        send: 'Wyślij',
        shopClosed: '{shopName} jest teraz zamknięty. Odpowiemy w godzinach pracy.',
        shopClosingInAMinute: '{shopName} zamyka się za minutę.',
        shopClosingInLessThanAMinute: '{shopName} zamyka się za mniej niż minutę.',
        tapToRetry: 'Wiadomość nie została dostarczona. Dotknij, aby ponowić.',
        thanksForReachingOut: 'Dziękujemy za kontakt!',
        waitTimeAgentsAreBusySorryToHearThat: 'Łączymy z naszym zespołem. Czas oczekiwania przekracza 15 minut.',
        waitTimeMediumSorryToHearThat: 'Łączymy z naszym zespołem. Odpowiemy za około {waitTime} min.',
        waitTimeShortSorryToHearThat: 'Łączymy z naszym zespołem. Zaraz się odezwiemy.',
        uploadFileSmallerThan: 'Dodaj plik mniejszy niż {maxFileSize} MB.',
        requiredEmail: 'Adres e-mail jest wymagany',
        aiAgentEmailHandoverConfirmationMessage: 'Twoja wiadomość dotarła do nas. Ktoś z naszego zespołu odpowie e-mailem w ciągu 48 godzin. Nie musisz zaczynać nowej rozmowy w tej sprawie – mamy wszystko, czego potrzebujemy. Dziękujemy za cierpliwość!',
        aiPoweredChatDisclaimerText: 'Ten czat korzysta z AI, żeby szybciej Ci pomóc.',
        privacyNoticeAiBody: 'Ten czat korzysta z AI, żeby szybciej Ci pomóc.'
      });
      chat.updateSSPTexts(SSP_TEXTS_PL);
    } catch (e) { /* older bundle without some keys */ }

    setOpenState(chat.isOpen());
    chat.on('widget:opened', function () { setOpenState(true); scanIframes(); });
    chat.on('widget:closed', function () { setOpenState(false); });
    chat.on('unreadCount', function (n) { setUnread(n); });

    root.classList.add('nk-chat-ready');
    teaserTimer = setTimeout(showTeaser, TEASER_DELAY);
  }

  function waitForGorgias(attempts) {
    if (window.GorgiasChat && typeof window.GorgiasChat.init === 'function') {
      window.GorgiasChat.init().then(configure);
      return;
    }
    if (attempts > 0) setTimeout(function () { waitForGorgias(attempts - 1); }, 300);
  }

  function start() {
    buildHostUi();
    scanIframes();
    new MutationObserver(scanIframes).observe(document.body, { childList: true, subtree: true });
    waitForGorgias(100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
